export default __webpack_public_path__ + "static/media/chatBackground.71c8d816.png";